<div class="container mb-1">
  <div class="row col-6">
    <ziro-radio fieldId="enterByType"></ziro-radio>
  </div>

  <div class="row col-6" [hidden]="formData.enterByType !== 'Text'">
    <ziro-textarea fieldId="bulkNumbers"></ziro-textarea>
  </div>

  @if (formData.enterByType !== 'Text') {
    <div class="row col-6">
      <label
        [ngClass]="{
          'ziro-forms-error': extensionRangesDisplayFormValidationState === validationStates.INVALID,
          'ziro-forms-warning': extensionRangesDisplayFormValidationState === validationStates.WARNING,
        }"
        data-automation="extension-ranges-label"
        class="ziro-forms-label col-form-label"
      >
        <span class="text-danger ziro-forms-asterisk">*</span>
        <span>
          {{ 'tkey;admin.order_numbers.check_number_portability.ranges.label' | translate }}
        </span>
      </label>
      <ziro-extension-ranges-display-form
        data-automation="extension-ranges-display-form"
        [entity]="rangesFormEntity"
        [optionalValidators]="rangesFormOptionalValidators"
        [isRequired]="true"
        [isZpm]="true"
        (ziroFormsUpdate$)="onRangeFormUpdate($event)"
      ></ziro-extension-ranges-display-form>
    </div>
  }
</div>
